"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.privacy = void 0;
exports.privacy = function (axios) {
    return {
        getPrivacyAccessHistories: function (request) {
            return axios.get('/privacy-access-histories', request);
        },
        postPrivacyAccessHistories: function (request) {
            return axios.post('/privacy-access-histories', request.data);
        }
    };
};
